import React from 'react';
import image from '../arktemis media/scifi-4916165_1280.jpg';

const About = () => {
  const video = '/earth.mp4';
  return (
    <div className="bg-black text-white pt-20 min-h-screen">
      {/* Section with Background Image */}
      <section className="relative w-full min-h-[70vh] md:min-h-[80vh] flex justify-center items-center text-white py-20 px-4">
        <img 
          src={image} 
          alt="Background" 
          className="absolute top-0 left-0 w-full h-full object-cover brightness-50 z-0" 
        />
        <div className="relative z-10 text-center max-w-5xl bg-black bg-opacity-70 backdrop-blur-md p-10 rounded-xl leading-relaxed border border-gray-700" data-aos="fade-up">
          <p className="text-xl md:text-2xl">
            Arktemis Foundation is a Systems-based Research Company specializing in sustainable resource management. We build resilient frameworks to tackle complex challenges in resource modeling, precision agriculture, water management, and more. Using our proprietary systems approach, we deliver solutions that are both economically and environmentally sustainable.
          </p>
        </div>
      </section>

      {/* Section with Video Background */}
      <section className="relative w-full min-h-[70vh] md:min-h-[80vh] flex justify-center items-center text-white py-20 px-4 mt-12 mb-12">
        {/* Video background covering entire container */}
        <video 
          src={video} 
          autoPlay 
          loop 
          muted 
          playsInline
          preload="metadata"
          className="absolute top-0 left-0 w-full h-full object-cover brightness-50 z-0" 
          aria-label="Arktemis about page background video"
          onPlay={() => window.gtag?.('event', 'video_play', { event_category: 'video', event_label: 'about_page_video' })}
        />
        <div className="relative z-10 text-left max-w-5xl bg-black bg-opacity-70 backdrop-blur-md p-10 rounded-xl border border-gray-700" data-aos="fade-right">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent leading-tight">The Future of Geospatial Intelligence</h1>
          <p className="text-xl md:text-2xl leading-relaxed text-gray-300">
            At Arktemis Foundation, we go beyond standard GIS products with our in-house framework, designed for extreme accuracy. We enable clients with detailed reports and actionable insights, using a rigorous methodology that integrates raw satellite data, ground measurements, demographics, scientific planning, automation and more. Our in-depth consultancy unlocks the full potential of satellite-based intelligence, delivering unmatched precision and value.
          </p>
        </div>
      </section>

      {/* Our Vision Section */}
      <section className="w-full bg-black-900 py-20 px-4 text-center border-b border-gray-800">
        <div className="container mx-auto max-w-5xl" data-aos="fade-up">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">Our Vision</h1>
          <p className="text-xl md:text-2xl leading-relaxed mx-auto text-gray-300">
            To revolutionize resource management and automation in agriculture, land use, and water systems—bridging technology with sustainability for a smarter, more resilient future.
          </p>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="w-full bg-black py-20 px-4 text-center border-b border-gray-800">
        <div className="container mx-auto max-w-5xl" data-aos="fade-up">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">Our Mission</h1>
          <p className="text-xl md:text-2xl leading-relaxed mx-auto text-gray-300">
            We promote sustainable, climate-resilient farming practices, leverage advanced geospatial mapping for data-driven decision-making, and develop robotics and automation solutions to enhance efficiency in precision agriculture. Our consultancy services help businesses integrate sustainability and achieve ESG compliance. Through innovation and technology, we create solutions that are both efficient and environmentally responsible.
          </p>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="w-full bg-black-900 py-20 px-4 text-center">
        <div className="container mx-auto max-w-5xl" data-aos="fade-up">
          <h1 className="text-4xl md:text-5xl font-bold mb-12 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">Why Choose Us?</h1>
          <div className="text-xl md:text-2xl space-y-6 mx-auto text-gray-300">
            <p data-aos="fade-left" data-aos-delay="100" className="transition-all duration-300 transform hover:scale-105 hover:text-blue-400"><strong className="text-white">Built from Scratch:</strong> We process raw satellite data into high-accuracy GIS products.</p>
            <p data-aos="fade-left" data-aos-delay="200" className="transition-all duration-300 transform hover:scale-105 hover:text-blue-400"><strong className="text-white">Custom-Tailored Solutions:</strong> Scalable insights designed for your specific needs.</p>
            <p data-aos="fade-left" data-aos-delay="300" className="transition-all duration-300 transform hover:scale-105 hover:text-blue-400"><strong className="text-white">Real-Time, Data-Driven Intelligence:</strong> Make decisions with the latest geospatial analytics.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;